import React from 'react'

const Support = () => {
  return (
    <div style={{marginTop:"80px"}}>Support</div>
  )
}

export default Support